import React from 'react';
import { render } from 'react-dom';
import BrandSearch from './BrandSearch';
import { MemoryRouter, Route } from "react-router-dom";
import { createBrowserHistory } from 'history';

// Customer ID to Google Analytics Tracking ID mapping
const CUSTOMER_TRACKING_MAP = {
    '711442': 'G-SY51P9L7SS',
    '710290': 'G-KYHVBLHWP8',
    // Add more customer mappings as needed
};

var brandSearchContainer = document.getElementById('BrandSearch');
console.log("BrandSearchContainer:", brandSearchContainer);
console.log("BrandSearchContainer.dataset:", brandSearchContainer.dataset);

if (brandSearchContainer != null) {
    const custId = brandSearchContainer.dataset.custid;
    const trackingId = CUSTOMER_TRACKING_MAP[custId];
    
    // Initialize Google Analytics with customer-specific tracking ID
    if (trackingId && typeof gtag === 'undefined') {
        console.log(`Loading Google Analytics for customer ${custId} with tracking ID ${trackingId}`);
        
        // Load gtag script
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
        
        // Wait for script to load before initializing
        script.onload = () => {
            console.log('Google Analytics script loaded successfully');
            
            // Initialize gtag
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            window.gtag = gtag;
            gtag('js', new Date());
            
            // Configure with customer-specific tracking
            gtag('config', trackingId, {
                page_title: 'Sierra Parts Embed',
                page_location: window.location.href,
                custom_parameter_embed_source: 'sierra_parts_embed',
                custom_parameter_customer_id: custId,
                custom_parameter_embed_version: '1.0'
            });

            // Track embed load event
            gtag('event', 'embed_loaded', {
                event_category: 'embed_interaction',
                event_label: 'sierra_parts_embed',
                custom_parameter_host_domain: window.location.hostname,
                custom_parameter_customer_id: custId
            });

            console.log(`Sierra Parts Embed: Google Analytics initialized for customer ${custId} with tracking ID ${trackingId}`);
            
            // Store tracking ID globally for use by analytics utility
            window.SIERRA_TRACKING_ID = trackingId;
            window.SIERRA_CUSTOMER_ID = custId;
            
            // Track embed entry after analytics is available
            setTimeout(() => {
                if (window.SierraPartsAnalytics) {
                    window.SierraPartsAnalytics.trackEmbedEntry();
                }
            }, 100);
        };
        
        script.onerror = () => {
            console.error('Failed to load Google Analytics script');
        };
        
        document.head.appendChild(script);
    }

    render(
        <MemoryRouter basename="/en-us/sonar-widget" history={createBrowserHistory}>
            <BrandSearch {...(brandSearchContainer.dataset)} />
        </MemoryRouter>,
        brandSearchContainer,
    );
}


